<template>
  <div class="slide-content">
    <div class="resize-body">
      <div class="resize-content" :style="`transform: translate(-50%,-50%) scale(${scaling})`">
        <div class="title-content">
          <img src="../../../assets/image/kjqg/index/kjfwms/kjfwms.png" class="zcqd-title" alt="">
        </div>
        <div class="kjfw-info">
          <div class="kjfw-item-main">
            <div class="item-title">{{activeCategroy.title}}</div>
            <div class="item-info">
              <div class="info-text">{{activeCategroy.info}}</div>
              <div class="info-more" @click="toList(activeCategroy.ind)">查看更多 >></div>
            </div>
          </div>
          <div class="kjfw-categroy">
            <div class="categroy-item" :class="{active: activeIndex == item.ind }" @click="toList(ind)" v-for="item,ind in categroyList" :key="ind" @mouseover="setCategroy(item)" @mouseleave="startSwiper()">{{item.title}}</div>
          </div>
        </div>
        <div class="more" @click="toMoreList()">查看更多</div>
      </div>
    </div>

  </div>
</template>

<script>
import services from "../../../assets/js/services.js"
import { mapActions } from "vuex";
export default {
  props: ["scaling"],
  mounted() {
    this.activeTimeout = setInterval(() => {
      if (this.activeIndex >= this.categroyList.length - 1) {
        this.activeIndex = 0

      } else {
        this.activeIndex = this.activeIndex + 1
      }
      this.activeCategroy = this.categroyList[this.activeIndex]
    }, 5000)
  },
  data() {
    return {
      specialId: services.KJQG_SPECIAL_ID,
      school_code: localStorage.getItem("schoolCode"),
      activeIndex: 0,
      activeTimeout: null,
      categroyList: [
        {
          title: "新技焕发古艺",
          info: "科技恰似一双双灵动的手，轻轻叩响古艺传承的新大门。当现代科技与古老技艺相遇，不是简单的叠加，而是一场跨越时空的对话与重塑。科技赋能，让沉淀千年的文化遗产，挣脱岁月的枷锁，以数字化的形态“复活”，让非遗不再是博物馆里的“老物件”，古建不再是风雨中沉默的旧影。从数字复原古建，到大数据为非遗画像，以创新之姿延续生命，激活千年传承，让古艺在新时代熠熠生辉。",
          ind: 0
        },
        {
          title: "智慧振兴乡村",
          info: "科技是激活乡村活力的密钥，为乡村振兴注入强劲动能。它打破城乡发展的技术壁垒，把先进理念与高效模式，送进田间地头、山林茶舍，农机“智慧”升级、“不毛地”变“米粮仓”，绘就乡村振兴新画卷。从林菇共育的生态农业循环智慧，到传统种植养殖的数字化升级；从荒地变良田的科技赋能，到特色产业的品牌塑造，科技让乡村资源被重新看见、深度挖掘。用科技力量激活乡土潜能，赋能产业发展，让乡村既有传承千年的烟火温度，又有拥抱未来的科技底气，驱动乡村走上产业兴、生态美、百姓富的振兴之路，绘就城乡共荣的美好图景。",
          ind: 1
        },
        {
          title: "数智赋能教育",
          info: "数智浪潮席卷教育领域，掀起一场深刻变革。打破时空边界，数智重塑教育生态。“链接山海”架起知识桥梁，跨越山川湖海，让偏远角落的孩子也能同步共享优质教育资源；科技重塑教学形态，把枯燥知识转化为生动体验，让经典不再是静态文字，而是可交互、可探索的场景，知识传播跳出传统框架。从课堂互动到思维拓展，从公平普惠到创新突破，数智化正以磅礴之力，数智化重构教育生态，为万千学子点亮成长灯塔，为“教育强国”筑牢根基，让教育真正成为照亮人生的希望之光。",
          ind: 2
        },
        {
          title: "智能便捷生活",
          info: "数智浪潮席卷，浸润生活的每个角落，重构生活图景。它让家居更“聪明”，空调懂你所需、“未来式”牙刷守护健康；让消费更有趣，万物冻干拓展生活创意；让出行更灵动，随时开启“起飞”想象。从城市净水守护饮水安全，到智能服务简化生活流程，科技把便捷、高效、新奇，注入衣食住行。以数智为支点，撬动生活无限可能，打破传统生活边界，让智能融入日常肌理，让便捷成为生活常态，解锁数智时代专属的美好体验，重新定义“生活”二字的内涵。",
          ind: 3
        },
        {
          title: "科技守护健康",
          info: "科技是守护健康的坚固盾牌，为民生安康筑牢防线。它深入生命科学前沿，探索大脑奥秘、解码基因密码，让疾病早筛、精准诊疗成为现实；它构建智慧医疗网络，打破医院围墙，让诊疗数据流通、医疗服务协同。从“医·健康”的精准守护，到“慧·城市”的医疗协同，“医路前行”突破边界，用创新科技解码生命、守护健康，从疾病防治到健康管理，全方位守护，让科技温度融入医疗服务，为民生安康撑起科技保护伞。",
          ind: 4
        },
        {
          title: "智慧绿水青山",
          info: "科技是生态保护的智慧引擎，驱动人与自然和谐共生。它为生态监测装上“千里眼”“顺风耳”，紧盯山水林田湖草的细微变化；为环境修复打造“手术刀”，让受损生态重回生机；为绿色发展开辟新路径，从“零碳之路”探索到“再造地球”尝试。聚焦“亚洲水塔”守护、“空中秘境”探秘，科技借数据监测、创新技术，守护水土、调控气候。让智慧与生态同频，以科技守护绿水青山，绘就山水相依、人城共荣、和谐共生的生态画卷。",
          ind: 5
        },
      ],
      activeCategroy: {
        title: "新技焕发古艺",
        info: "科技恰似一双双灵动的手，轻轻叩响古艺传承的新大门。当现代科技与古老技艺相遇，不是简单的叠加，而是一场跨越时空的对话与重塑。科技赋能，让沉淀千年的文化遗产，挣脱岁月的枷锁，以数字化的形态“复活”，让非遗不再是博物馆里的“老物件”，古建不再是风雨中沉默的旧影。从数字复原古建，到大数据为非遗画像，以创新之姿延续生命，激活千年传承，让古艺在新时代熠熠生辉。",
        ind: 0
      }


    }
  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin"]),
    toMoreList() {
      this.goAppsDetailsBeforeLogin().then(() => {
        let routeUrl = this.$router.resolve({
          path: `/${this.school_code}/kjqg/kjfwms?ind=0`,
        });
        window.open(routeUrl.href, "_blank");
      });

    },
    toList(ind) {
      this.goAppsDetailsBeforeLogin().then((res) => {
        let routeUrl = this.$router.resolve({
          path: `/${this.school_code}/kjqg/kjfwms?ind=${ind}`
        })
        window.open(routeUrl.href, "_blank");
      });

    },
    setCategroy(item) {
      this.activeCategroy = item
      this.activeIndex = item.ind
      clearInterval(this.activeTimeout)
    },
    startSwiper() {
      this.activeTimeout = setInterval(() => {
        if (this.activeIndex >= this.categroyList.length - 1) {
          this.activeIndex = 0

        } else {
          this.activeIndex = this.activeIndex + 1
        }
        this.activeCategroy = this.categroyList[this.activeIndex]
      }, 5000)
    }

  }
}
</script>

<style lang="less" scoped>
.slide-content {
  padding-top: 5.16vw;

  background-size: cover;
  background-position: center;
  height: 100%;
  position: relative;
  .resize-body {
    position: relative;
    width: 100%;
    height: 100%;
    .resize-content {
      // height: 100%;
      width: 1920px;
      transform-origin: center center;
      height: 981px;
      position: absolute;
      top: 50%;
      left: 50%;
      .title-content {
        // margin: 0 auto;
        text-align: center;
        .zcqd-title {
          max-width: 580px;
          margin-top: 30px;
        }
      }
      .kjfw-info {
        width: 1400px;
        height: 688px;
        margin: 44px auto 0;
        position: relative;
        .kjfw-item-main {
          width: 1400px;
          height: 256px;
          background-image: url("../../../assets/image/kjqg/index/kjfwms/kjfw-item-main.png");
          background-size: cover;
          background-position: center;
          padding: 25px 53px 25px 40px;
          display: flex;
          .item-title {
            font-weight: bold;
            font-size: 18px;
            letter-spacing: 6px;
            color: #174bca;
            line-height: 77px;
            height: 100%;
            text-align: center;
            writing-mode: vertical-lr;
          }
          .item-info {
            flex: 1;
            overflow: hidden;
            .info-text {
              margin: 22px 60px 10px 15px;
              font-weight: 400;
              font-size: 16px;
              color: #494d53;
              line-height: 32px;
              height: 128px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 4; /* 控制显示的行数 */
              min-height: 100px;
            }
            .info-more {
              font-size: 16px;
              color: #174bca;
              line-height: 26px;
              width: 100px;
              text-align: center;
              margin: 0 60px 0 auto;
              cursor: pointer;
            }
          }
        }
        .kjfw-categroy {
          display: flex;
          margin-top: 86px;
          padding: 0 24px;
          justify-content: space-between;
          .categroy-item {
            width: 188px;
            height: 188px;
            background-size: cover;
            background-position: center;
            font-weight: bold;
            font-size: 18px;
            color: #2b427c;
            line-height: 44px;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            cursor: pointer;
            &:hover {
              color: #fff;
            }
            &.active {
              color: #fff;
            }
            &:nth-child(even) {
              margin-top: 83px;
            }
            &:nth-child(1) {
              background-image: url("../../../assets/image/kjqg/index/kjfwms/categroy-1.png");

              &.active {
                background-image: url("../../../assets/image/kjqg/index/kjfwms/categroy-1-hover.png");
              }
            }
            &:nth-child(2) {
              background-image: url("../../../assets/image/kjqg/index/kjfwms/categroy-2.png");

              &.active {
                background-image: url("../../../assets/image/kjqg/index/kjfwms/categroy-2-hover.png");
              }
            }
            &:nth-child(3) {
              background-image: url("../../../assets/image/kjqg/index/kjfwms/categroy-3.png");

              &.active {
                background-image: url("../../../assets/image/kjqg/index/kjfwms/categroy-3-hover.png");
              }
            }
            &:nth-child(4) {
              background-image: url("../../../assets/image/kjqg/index/kjfwms/categroy-4.png");

              &.active {
                background-image: url("../../../assets/image/kjqg/index/kjfwms/categroy-4-hover.png");
              }
            }
            &:nth-child(4) {
              background-image: url("../../../assets/image/kjqg/index/kjfwms/categroy-4.png");

              &.active {
                background-image: url("../../../assets/image/kjqg/index/kjfwms/categroy-4-hover.png");
              }
            }
            &:nth-child(5) {
              background-image: url("../../../assets/image/kjqg/index/kjfwms/categroy-5.png");
              &.active {
                background-image: url("../../../assets/image/kjqg/index/kjfwms/categroy-5-hover.png");
              }
            }
            &:nth-child(6) {
              background-image: url("../../../assets/image/kjqg/index/kjfwms/categroy-6.png");

              &.active {
                background-image: url("../../../assets/image/kjqg/index/kjfwms/categroy-6-hover.png");
              }
            }
          }
        }
      }
      .more {
        width: 148px;
        height: 47px;
        line-height: 47px;
        background-image: url("../../../assets/image/kjqg/index/xskj/more.png");
        background-size: cover;
        font-weight: 400;
        font-size: 16px;
        color: #0c6aef;
        text-align: center;
        margin: 58px auto 0;
        cursor: pointer;
      }
    }
  }
}
</style>